import { Component, defineComponent } from '@decify/cell-shopify/client';
import './ProductOptionSelector.scss';
export const productOptionSelectorName = 'ProductOptionSelector';
export const productOptionSelectorTagName = 'cell-component-product-option-selector';
export const productOptionSelectorChangeEvent = 'change';
export class ProductOptionSelector extends Component {
    constructor() {
        super('ProductOptionSelector');
        this.validateProps(['position']);
        this.handleChange = this.handleChange.bind(this);
    }
    componentDidMount() {
        this.subscribe('change', this.handleChange);
    }
    handleChange(_, event) {
        // Sanity check.
        if (!(event.target instanceof HTMLInputElement))
            return;
        const { value } = event.target;
        this.publish(productOptionSelectorChangeEvent, {
            value,
            position: this.props.position,
        });
    }
}
defineComponent(productOptionSelectorTagName, ProductOptionSelector);
